/* eslint-disable @wix/da/import-scss-last */
import Modal from 'react-modal';
import { hydrateRoot } from 'react-dom/client';
import { getClientInstance } from '@wix/da-ddt';
import initI18n from '@wix/da-i18next/pkg/presetI18nClientConfigNg';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import { configureStore } from './store/configure-store';
// project-base needs to go before app styles
import '@wix/da-ds/src/styles/project-base.scss';
import App from './components/forums/App';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const store = configureStore(initialState);
const state = store.getState();

const initialI18n = window['__INITIAL_I18N__'];
initI18n(
  {
    ...initialI18n,
    options: {
      defaultNS: 'forums',
      fallbackNS: 'translation',
    },
  },
  getEnv(state).isDebug,
  getEnv(state).flags
);

Modal.setAppElement('body');

hydrateRoot(
  document,
  <I18nextProvider i18n={i18n}>
    <AppDocumentWrapper store={store}>
      <App language={initialI18n.locale} />
    </AppDocumentWrapper>
  </I18nextProvider>
);
